import { render, staticRenderFns } from "./SidebarGroupCollapsed.vue?vue&type=template&id=15b38330&"
import script from "./SidebarGroupCollapsed.vue?vue&type=script&lang=js&"
export * from "./SidebarGroupCollapsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports